import { motion, AnimatePresence } from "framer-motion";
import LoginCard from "./LoginCard";

interface LoginOverlayProps {
  isOpen: boolean;
  onClose: () => void;
  onSuccess: () => void;
}

export default function LoginOverlay({ isOpen, onClose, onSuccess }: LoginOverlayProps) {
  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.3 }}
          className="fixed inset-0 z-[100] flex items-center justify-center"
          style={{ padding: '2rem' }}
        >
          {/* Backdrop */}
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="absolute inset-0 bg-black/70 backdrop-blur-sm"
            onClick={onClose}
          />

          {/* Login Card */}
          <div className="relative z-10">
            <LoginCard
              onSuccess={onSuccess}
              onClose={onClose}
              showCloseButton={true}
            />
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
